import React from 'react'
import { useParams } from 'react-router-dom'
import { useGoBackOrRedirect } from '@@partner:helpers/hooks/location'

import CategoryForm from '@components/catalog/category/CategoryForm'

import { ROUTE_CATALOG_CATEGORIES } from '@@partner:config/routes'

export default function CatalogCategoryPage () {

  const { categoryId, brandSlug } = useParams<any>()
  const redirectToCatalog = useGoBackOrRedirect(ROUTE_CATALOG_CATEGORIES, {
    brandSlug
  })

  return (
    <div className="CatalogCategoryPage">
      <h1 className="u-heading">
        {categoryId ? 'Редактирование' : 'Добавление'}
      </h1>
      <CategoryForm categoryId={categoryId} onSaved={redirectToCatalog} />
    </div>
  )
}
